@if (block.items && block.items.length) {
  <div class="carousel-block" [style.color]="block.textColor">
    @if (block.title) {
      <div class="carousel-block__header" [class.no-title]="!block.title">
        <h4 class="carousel-block__title" [rtl]="block.langcode">{{block.title}}</h4>
        @if (block.items.length > 1) {
          <div class="carousel-block__arrows" [style.color]="block.textColor">
            <button class="button button--icon button--transparent" mat-icon-button [disabled]="swiperComponent?.swiper?.isBeginning" (click)="swiperComponent?.swiper.slidePrev()">
              <lib-icon icon="arrow-left"></lib-icon>
            </button>
            <button class="button button--icon button--transparent" mat-icon-button [disabled]="swiperComponent?.swiper?.isEnd" (click)="swiperComponent?.swiper.slideNext()">
              <lib-icon icon="arrow-right"></lib-icon>
            </button>
          </div>
        }
      </div>
    }
    <lib-swiper [slides]="block.items" [options]="swiperOptions">
      <ng-template swiperContent let-item="item">
        <div class="carousel-block__item">
          @if (item.link?.uri) {
            <a [extendedRouterLink]="item.link.uri" class="carousel-block__item-link">
              <ng-container *ngTemplateOutlet="carouselContentTmp"></ng-container>
            </a>
          } @else {
            <img [cropImage]="item.mediaImage | preSignedUrl | async" [attr.alt]="item.mediaImage?.alt">
            <div class="carousel-block__item-content d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-center justify-content-sm-between">
              <h3 [innerHtml]="item.title | safeHtml" [style.color]="block.textColor" [rtl]="item.langcode"></h3>
              @if (item.link?.title) {
                <button mat-flat-button class="button button--primary button--large mt-4 mt-sm-0" [style.background-color]="item.buttonColor" [style.color]="item.buttonTextColor">
                  <span class="button-text" [rtl]="block.langcode">{{item.link.title}}</span>
                  <mat-icon iconPositionEnd [class.secondary-color]="!item.buttonTextColor">navigate_next</mat-icon>
                </button>
              }
            </div>
          }
          <ng-template #carouselContentTmp>
            <img [cropImage]="item.mediaImage | preSignedUrl | async" [attr.alt]="item.mediaImage?.alt">
            <div class="carousel-block__item-content d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-center justify-content-sm-between">
              <h3 [innerHtml]="item.title | safeHtml" [style.color]="block.textColor" [rtl]="item.langcode"></h3>
              @if (item.link?.title) {
                <button mat-flat-button class="button button--primary button--large mt-4 mt-sm-0" [style.background-color]="item.buttonColor" [style.color]="item.buttonTextColor">
                  <span class="button-text" [rtl]="block.langcode">{{item.link.title}}</span>
                  <mat-icon iconPositionEnd [class.secondary-color]="!item.buttonTextColor">navigate_next</mat-icon>
                </button>
              }
            </div>
          </ng-template>
        </div>
      </ng-template>
    </lib-swiper>
  </div>
}
